module.exports = __webpack_public_path__ + "img/equipo-de-trabajo-ofis-mobile.b4680667.jpg";